"use strict";
//
// Copyright © 2025 Hardcore Engineering Inc.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAvatarProvider = getAvatarProvider;
exports.getAvatarUrlInfo = getAvatarUrlInfo;
exports.getAvatarDisplayName = getAvatarDisplayName;
const platform_1 = require("@hcengineering/platform");
const _1 = __importStar(require("."));
const providers = new Map();
async function getAvatarProvider(client, providerId) {
    const provider = providers.get(providerId);
    if (provider !== undefined) {
        return provider ?? undefined;
    }
    const res = await client.findOne(_1.default.class.AvatarProvider, { _id: providerId });
    providers.set(providerId, res ?? null);
    return res;
}
async function getAvatarUrlInfo(client, avatar, width, name) {
    let url;
    let srcSet;
    let color;
    const displayName = getAvatarDisplayName(name);
    if (avatar != null) {
        const avatarProviderId = (0, _1.getAvatarProviderId)(avatar.avatarType);
        const avatarProvider = avatarProviderId !== undefined ? await getAvatarProvider(client, avatarProviderId) : undefined;
        if (avatarProvider !== undefined) {
            const getUrlHandler = await (0, platform_1.getResource)(avatarProvider.getUrl);
            ({ url, srcSet, color } = await getUrlHandler(avatar, displayName, width));
        }
    }
    return {
        url,
        srcSet,
        color
    };
}
function getAvatarDisplayName(name) {
    if (name == null) {
        return '';
    }
    const lastFirst = (0, platform_1.getMetadata)(_1.default.metadata.LastNameFirst) === true;
    const fname = (0, _1.getFirstName)(name ?? '').trim()[0] ?? '';
    const lname = (0, _1.getLastName)(name ?? '').trim()[0] ?? '';
    return lastFirst ? lname + fname : fname + lname;
}
//# sourceMappingURL=avatar.js.map